import * as React from 'react';

import { FIELD_PATHS } from '@funnels/constants';
import { AssetEntityIndex } from '@funnels/types';

import { EditableViewProps, StringReadOnlyViewProps, FunnelViewProps } from '../types';
import { DatePickerInputField, StringDisplay } from '../../Fields';
import HelpTooltip from '../../_common/HelpTooltip';
import { DatePickerInputFieldProps } from '../../Fields/DatePickerInputField';

interface SettlementDateFunnelProps extends FunnelViewProps, AssetEntityIndex {}

export const SettlementDateFunnelView = (props: SettlementDateFunnelProps) => {
  const { assetIndex = 0, ...rest } = props;
  return (
    <DatePickerInputField
      {...rest}
      label={'Settlement date'}
      labelAfter={
        <HelpTooltip content={'This is here just for HLS reference. It will not be asked in the customer funnel.'} />
      }
      name={FIELD_PATHS.ASSET_ESTIMATED_SETTLEMENT_DATE(assetIndex)}
      hasDayField
    />
  );
};

export const SettlementDateReadOnlyView = (props: StringReadOnlyViewProps) => (
  <StringDisplay title={'Settlement date'} value={props.value} />
);

interface SettlementDateEditableProps
  extends EditableViewProps,
    AssetEntityIndex,
    Omit<DatePickerInputFieldProps, 'name'> {}

export const SettlementDateEditableView = (props: SettlementDateEditableProps) => {
  const { assetIndex = 0, label = 'Settlement date', ...rest } = props;
  return (
    <DatePickerInputField
      {...rest}
      label={label}
      name={FIELD_PATHS.ASSET_ESTIMATED_SETTLEMENT_DATE(assetIndex)}
      hasDayField
    />
  );
};
